import React from "react";

import Main from "../components/Main";

import BookCategories from "../components/SlidingImagesAnimation.js";

import { Content } from "../components/Content";

const Home = () => {

  return (

    <>

      <Main />

      <BookCategories />

      <Content />

    </>

  );

};

export default Home;